import { FC } from 'react'

import { TAX_FREE_THRESHOLD } from '@/api/payments/paymentsService'
import { AppDialog } from '@/components/AppDialog'
import { Divider } from '@/components/Divider'
import UniteIcon from '@/components/icons/pkg-unite.svg?react'
import { Button } from '@/components/ui/button'

interface UniteConfirmationDialogProps {
  isOpen: boolean
  onClose: () => void
  onConfirm: (shouldShrink?: boolean) => void
  isLoading?: boolean
  isFreeUnite?: boolean
  isUSWarehouse?: boolean
  packageCount?: number
}

export const UniteConfirmationDialog: FC<UniteConfirmationDialogProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading = false,
  isFreeUnite,
  isUSWarehouse = false,
}) => {
  return (
    <AppDialog isOpen={isOpen} onOpenChange={onClose} className='!max-w-lg'>
      <div className='flex flex-col items-center gap-6'>
        {/* Icon and Title */}
        <div className='flex flex-col items-center gap-4'>
          <div className='h-6 w-6'>
            <UniteIcon className='text-icon-primary h-full w-full' />
          </div>
          <h2 className='text-text-primary text-center text-lg font-medium'>איחוד חבילות- חיסכון חכם!</h2>
        </div>

        {/* Description */}
        <div className='flex flex-col items-center gap-6'>
          <div className='text-text-secondary text-center text-sm leading-5'>
            <p className='mb-1'>אנחנו נאחד עבורכם חבילות וכך תוכל לחסוך דמי משלוח.</p>
            <p className='mb-1'>רק שימו לב! גובה המיסוי משתנה</p>
            <p className='mb-1'>בהתאם לסך כל המוצרים בחבילה המאוחדת.</p>
            <p>חבילות מעל ${TAX_FREE_THRESHOLD} עלולות להיות מחויבות במס</p>
            {isUSWarehouse && (
              <p className='font-medium'>עכשיו בנוסף לאיחוד החבילות אנחנו גם נסיר אריזות מיוצרות וככה נוכל להוזיל לכם את עלות השילוח.</p>
            )}
          </div>

          {/* Cost Info */}
          <div className='bg-button-primary-selected-segment text-text-secondary rounded-full px-3 py-2'>
            <p className='text-center text-xs'>
              {isFreeUnite ? 'זיהינו שמדובר בחבילה מפוצלת ולכן האיחוד חינם 😊' : 'השירות כרוך בתשלום של $1.5 לכל חבילה ויחושב בחשבון הסופי'}
            </p>
          </div>
          <p className='text-text-secondary text-xs'>ניתן לבטל בקשת איחוד טרם ביצועה ע"י לחיצה על כפתור הביטול.</p>
        </div>
        <Divider />
        {/* Action Button */}
        <div className='flex items-center justify-center gap-6'>
          {isUSWarehouse ? (
            <>
              <Button variant='outline' className='font-normal' size='lg' disabled={isLoading} onClick={() => onConfirm(false)}>
                איחוד חבילות בלבד
              </Button>
              <Button disabled={isLoading} onClick={() => onConfirm(true)} size='lg'>
                אשמח לצמצום ואיחוד חבילות!
              </Button>
            </>
          ) : (
            <Button disabled={isLoading} onClick={() => onConfirm()} size='lg'>
              כן, אחדו לי חבילות!
            </Button>
          )}
        </div>
      </div>
    </AppDialog>
  )
}
